import React from 'react';

const useForwardRef = (ref, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
initial = null) => {
    const _ref = React.useRef(initial);
    React.useEffect(() => {
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(_ref.current);
        }
        else {
            _ref.current = ref.current;
        }
    });
    return _ref;
};

export { useForwardRef };
//# sourceMappingURL=useForwardRef.js.map
